import { useQueryApi } from 'utils/api'

import type { CommonResponse } from 'types/api'
import type {
  ProfileCompetencyContentCollectionData,
  ProfileCompetencyData,
} from 'types/competency-profile'
import type { CommonErrorResponse } from 'api/microlearning/types'
import type { UseQueryOptions } from 'react-query'

const BASE_PATH = '/guru/content-platform/v1alpha1/competency-profile'

export function useApiCompetencyProfile(
  assessmentType: string,
  opts?: UseQueryOptions<
    CommonResponse<ProfileCompetencyData[]>,
    CommonErrorResponse
  >
) {
  return useQueryApi<
    CommonResponse<ProfileCompetencyData[]>,
    CommonErrorResponse
  >(`${BASE_PATH}/${assessmentType}`, {
    queryConfig: {
      ...opts,
    },
  })
}

export function useApiCompetencyProfileContentCollection(
  types: Array<string> | string,
  opts?: UseQueryOptions<
    CommonResponse<ProfileCompetencyContentCollectionData[]>,
    CommonErrorResponse
  >
) {
  return useQueryApi<
    CommonResponse<ProfileCompetencyContentCollectionData[]>,
    CommonErrorResponse
  >(`${BASE_PATH}/content-collection`, {
    axiosConfig: {
      params: {
        types,
      },
    },
    queryConfig: {
      ...opts,
    },
  })
}
